import { render, staticRenderFns } from "./i-icon.vue?vue&type=template&id=a11e2024"
import script from "./i-icon.vue?vue&type=script&lang=js"
export * from "./i-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports